import React from 'react';
import { Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Stack } from "@mui/system";

const NotFound = () => {
    return (
        <Stack minWidth="sm" height="100%" alignItems="center" justifyContent="center" mb={12} ml={3} spacing={3}>
            <Typography variant="h1" pb={1.5}>404</Typography>
            <Typography variant="h4" align="center" color="text.secondary">
                Page Not Found
            </Typography>
            <Typography variant="h6" align="center" color="text.secondary">
                The page you are looking for does not exist.
            </Typography>
            <Button component={Link} to="/" color="secondary" variant="contained" size="large">
                Home
            </Button>
        </Stack>
    );
};

export default NotFound;